// Will retry api request 3 times by default
const defaultRetryCount = 3

/**
 * Retries an asynchronous function that has API request for a specified number of times if the initial {requestStatus} is not `fulfilled`.
 * @param callback A function that returns a Promise resolving to `boolean` type representing the API response request status.
 * @param retryCount (Optional) The number of times to retry the API request. Default is `3`.
 * @example
 *
 * // Make a retry function that contains the api async thunk call being dispatched //
 * // Be sure to return a boolean where it checks if the request is `fulfilled` //
 * const retryFunction = async () => {
 *   return ( ( await dispatch(reduxServices.serviceSlice.apiThunkCall()) ).meta.requestStatus === 'fulfilled' )
 * }
 *
 * // Call the retry function in the util helper  //
 * asyncApiRetryHelper(retryFunction)
 * @note This util helper is only for specific use case, not recommended for normal api dispatch call.
 */
export const asyncApiRetryHelper = async (
  callback: () => Promise<boolean>,
  retryCount: number = defaultRetryCount,
): Promise<void> => {
  let response = await callback()
  let retryCtr = 0
  while (retryCtr < retryCount) {
    if (!response) {
      response = await callback()
      retryCtr++
      console.debug('Retry count:', retryCtr, 'Response:', response)
      continue
    }
    break
  }
  console.assert(
    retryCtr !== retryCount,
    `An api has retried for ${retryCount}, no changes in server response.`,
  )
}
